module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAARtJREFUOI3Nk7GBgzAMRb84hiDdjSAgfZzJHI9yk2D6I3iLyxTRFdhGToA6qmxJfD1JBvg0I31h7uziJQMhF8Kv34qHcHevQl9FEtENgAeqH5DYpjl9Px5/YxEnMk1zQvIXRMxnAxIb5ulaELT9ABG/UpZnTVYtAbEQesOFiE8UukiYpyuITB5FFgIAPC9vQqhGAP6VNIvpzFx5y/ZIk5hqLW+N214A+PXD50W3pJaBLcrcWpgnihQDSAaNz20/RPIbhJJP9kiRKushMp9NFjrIqzN2bpZM9MW7mN05LblOtVaNm4mLmYONZqsBIP4KXpOkjTB3ReWVRqzedn1AkgWZu/jKyaVt6mKqtWPsEO4OQg4kyyxFNh/pZ9k/2puW9JCNk3cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliSex.png
// module id = BOLN
// module chunks = 1